import { ApiService } from "$/services/ApiService.js";
import { ServiceConsts } from "$/services/ServiceConsts.js";
import { LocalStorage } from "$/services/LocalStorage.js";
import { v4 as uuid } from "uuid";
export class CopilotService {
    static async getBaseUrl() {
        return `${ServiceConsts.API_URL}/copilot`;
    }
    static async createQuery(query, count) {
        let url = await this.getBaseUrl();
        count = count !== null && count !== void 0 ? count : 30;
        let createdQuery = await ApiService.post(`${url}/queries`, query, `count=${count}`);
        createdQuery.snippets = createdQuery.snippets.map((snippet) => {
            var _a;
            snippet.comments = (_a = snippet.comments) !== null && _a !== void 0 ? _a : [];
            snippet.url = snippet.urlPath;
            return snippet;
        });
        return createdQuery;
    }
    static async getQuery(queryId) {
        let url = await this.getBaseUrl();
        return await ApiService.get(`${url}/queries/${queryId}`);
    }
    static async createReaction(reactionValue, snippetId, queryId) {
        let url = await this.getBaseUrl();
        let reaction = reactionValue === 1 ? "upvote" : "downvote";
        return await ApiService.put(`${url}/queries/${queryId}/snippets/${snippetId}/reactions/${reaction}`);
    }
    static async createTopic(topic) {
        let tenant = await LocalStorage.get("activeTenant");
        let url = await this.getBaseUrl();
        url = tenant ? `${url}/${tenant.id}/topics` : `${url}/topics`;
        return await ApiService.post(url, topic);
    }
}
